export const inputs = {
    formName: 'forgotPasswordForm',
    type: {
        email: 'email',
    },
    field: {
        signInEmailAddress: 'signInEmailAddress',
    }
}
